// Entry point for helpers package
// Exports all utility functions for easy importing

// Import individual helper modules
import { api } from "./api.js";
import { costingCalc } from "./costing.js";
import { reports } from "./reports.js";
import { dayRange } from "./time.js";
import holidays2025 from "./holidays2025.json";
import holidays2026 from "./holidays2026.json";
import { newSocket } from "./socket.js";
import { hours } from "./hours.js";
import { enduserApi } from "./enduserApi.js";
// Named exports for tree shaking
export { api, costingCalc, reports, dayRange, holidays2025, holidays2026, newSocket, hours, enduserApi };

// Default export with all helpers organized by category
export default {
  api,
  costing: costingCalc,
  reports,
  dayRange,
  holidays2025,
  holidays2026,
  newSocket,
	hours,
	enduserApi,
};
